import React, {useState, useEffect, useLayoutEffect, useRef, useContext} from 'react'
import useFetch from '../../../hooks/fetchMSSQL-hook'
import PaginationEx from "../../../components/Pagination/PaginationExSm";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import ReportButton from "../../../components/Buttons/ReportButton"
import NoResults from "../../../components/NoResults/NoResults";
import {Link, Prompt} from "react-router-dom";
import {NavigationContext} from "../../../context/navigation-context";
import FormSkel from "../../../components/Modals/FormSkel";
import { NotificationManager } from 'react-notifications';

export const getInvoiceTotal = (invoice, details) => {
    const currentInvoiceDetails = details.filter(d => d.InvoiceId === invoice.InvoiceId);

    const totalValue = currentInvoiceDetails.reduce((total, d) => {
        const isItemPLN = d.IsPLN == 1;
        const multiplier = isItemPLN ? 1 : (invoice.PriceEUR || 0);
        const itemValue = (d.PriceNetto || 0) * (d.Quantity || 0) * multiplier;

        return total + itemValue;
    }, 0);

    return totalValue.toFixed(2);
};
const INVOICES_VIEW_KEY = 'invoices.listView';
const INVOICES_SCROLL_KEY = 'invoices.listScroll';

const readInvoicesView = () => {
    try {
        const saved = JSON.parse(sessionStorage.getItem(INVOICES_VIEW_KEY));
        if (!saved || typeof saved !== 'object') return {};
        return {
            filterYear: typeof saved.filterYear === 'number' ? saved.filterYear : '',
            filterMonth: Number.isInteger(saved.filterMonth) && saved.filterMonth >= 1 && saved.filterMonth <= 12 ? saved.filterMonth : '',
            filterClient: typeof saved.filterClient === 'string' ? saved.filterClient : '',
            searchTerm: typeof saved.searchTerm === 'string' ? saved.searchTerm : '',
            page: Number.isInteger(saved.page) && saved.page > 0 ? saved.page : 1,
            sortField: typeof saved.sortField === 'string' ? saved.sortField : 'InternalNumber',
            sortDir: saved.sortDir === 'ASC' ? 'ASC' : 'DESC'
        };
    } catch {
        return {};
    }
};

const Invoices = () => {
    const {fetchMssqlApi} = useFetch(),
        { setHeaderData } = useContext(NavigationContext)

    const now = new Date()
    const currentYear = now.getFullYear()
    const currentMonth = now.getMonth() + 1

    const [actionYear, setActionYear] = useState(currentYear)
    const [actionMonth, setActionMonth] = useState(currentMonth)
    const [actionClient, setActionClient] = useState('')

    const [savedView] = useState(readInvoicesView);
    const [filterYear, setFilterYear] = useState(savedView.filterYear || '')
    const [filterMonth, setFilterMonth] = useState(savedView.filterMonth || '')
    const [filterClient, setFilterClient] = useState(savedView.filterClient || '')
    const [searchTerm, setSearchTerm] = useState(savedView.searchTerm || '')

    const [clients, setClients] = useState([])
    const [invoices, setInvoices] = useState([]);
    const [generating, setGenerating] = useState(false);
    const [fetchingNbp, setFetchingNbp] = useState(false);

    const [invoicesDetails, setInvoicesDetails] = useState([])
    const [eurRate, setEurRate] = useState('');
    const [startInvoiceNumber, setStartInvoiceNumber] = useState('');

    const [page, setPage] = useState(savedView.page || 1);
    const [rowsPerPage] = useState(50);
    const [sortField, setSortField] = useState(savedView.sortField || 'InternalNumber');
    const [sortDir, setSortDir] = useState(savedView.sortDir || 'DESC');

    const [invoicesLoaded, setInvoicesLoaded] = useState(false);
    const scrollRestored = useRef(false);
    const savedScrollTop = useRef(0);

    useEffect(() => {
        try {
            const top = Number(sessionStorage.getItem(INVOICES_SCROLL_KEY));
            savedScrollTop.current = Number.isFinite(top) && top >= 0 ? top : 0;
        } catch {
            savedScrollTop.current = 0;
        }
        const saveScroll = () => {
            if (!scrollRestored.current) return;
            savedScrollTop.current = window.scrollY;
            try {
                sessionStorage.setItem(INVOICES_SCROLL_KEY, String(savedScrollTop.current));
            } catch {
            }
        };
        window.addEventListener('scroll', saveScroll, { passive: true });
        return () => window.removeEventListener('scroll', saveScroll);
    }, []);


    useEffect(() => {
        try {
            sessionStorage.setItem(INVOICES_VIEW_KEY, JSON.stringify({
                filterYear, filterMonth, filterClient, searchTerm, page, sortField, sortDir
            }));
        } catch {
        }
    }, [filterYear, filterMonth, filterClient, searchTerm, page, sortField, sortDir]);

    const getActionRange = (year, month) => {
        const y = Number(year) || currentYear;
        const m = Number(month) || currentMonth;
        const start = new Date(y, m - 1, 1);
        const end = new Date(y, m, 0);
        const from = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}-${String(start.getDate()).padStart(2, '0')} 00:00:00`;
        const to = `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')} 23:59:59`;
        const issuedFor = `${y}-${String(m).padStart(2, '0')}`;
        return { from, to, issuedFor, year: y, month: m };
    };

    const getInvoices = () => {
        fetchMssqlApi('invoices', {method: 'GET'}, res => {
            setInvoices(res[0][0]);
            setInvoicesDetails(res[0][1]);
            setInvoicesLoaded(true);
        });
    };

    useEffect(() => {
        getInvoices();
        setHeaderData({text: "Fakturowanie"});
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (generating) {
                e.preventDefault();
                e.returnValue = 'Trwa generowanie faktur. Czy na pewno chcesz opuścić stronę?';
                return e.returnValue;
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [generating]);

    useEffect(() => {
        let mounted = true
        const fetchClients = async () => {
            try {
                fetchMssqlApi('customers', {}, data => {
                    if (!mounted) return
                    setClients(Array.isArray(data) ? data : [])
                }, err => {
                    console.error(err)
                })
            } catch (err) {
                console.error(err)
            }
        }
        fetchClients()
        return () => {
            mounted = false
        }
    }, [])

    const fetchNbpRate = async () => {
        setFetchingNbp(true);
        try {
            const resp = await fetch('https://api.nbp.pl/api/exchangerates/rates/A/EUR/?format=json', {
                headers: { 'Accept': 'application/json' }
            });
            if (resp.ok) {
                const json = await resp.json();
                const rate = json && json.rates && json.rates[0] && json.rates[0].mid;
                if (rate) {
                    const formatted = Number(rate).toFixed(4);
                    setEurRate(formatted.replace(',', '.'));
                    NotificationManager.success(`Pobrano kurs NBP: ${formatted}`);
                    setFetchingNbp(false);
                    return;
                }
            }
            throw new Error('Direct fetch failed');
        } catch (directErr) {
            console.warn('Bezpośrednie pobranie kursu NBP nie powiodło się, pobieranie przez serwer...', directErr);
            fetchMssqlApi(
                'invoices/nbp-eur',
                { method: 'GET', showLoader: false },
                res => {
                    setFetchingNbp(false);
                    const rate = res && (res.rate || (res.data && res.data.rate));
                    if (rate) {
                        const formatted = Number(rate).toFixed(4);
                        setEurRate(formatted.replace(',', '.'));
                        NotificationManager.success(`Pobrano kurs NBP: ${formatted}`);
                    } else {
                        NotificationManager.error('Nie udało się pobrać kursu NBP');
                    }
                },
                err => {
                    setFetchingNbp(false);
                    console.error('NBP rate fetch error:', err);
                    NotificationManager.error('Błąd podczas pobierania kursu NBP');
                }
            );
        }
    };

    const generateInvoices = async () => {
        try {
            setGenerating(true);
            const range = getActionRange(actionYear, actionMonth);
            const parsedEur = eurRate ? parseFloat(String(eurRate).replace(',', '.')) : null;
            const body = {
                from: range.from,
                to: range.to,
                customerAbbr: actionClient || null,
                startNumber: (startInvoiceNumber && Number(startInvoiceNumber) >= 1) ? Number(startInvoiceNumber) : null,
                eurRate: (parsedEur && parsedEur > 0) ? parsedEur : null,
            };
            fetchMssqlApi(
                'invoices/generate',
                { method: 'POST', data: body, showLoader: false },
                () => {
                    getInvoices();
                    setGenerating(false);
                    setFormSkelOpen(false);
                    NotificationManager.success('Faktury zostały wygenerowane pomyślnie!');
                },
                err => {
                    console.error('generateInvoices error', err);
                    setGenerating(false);
                    NotificationManager.error('Błąd podczas generowania faktur');
                }
            );
        } catch (err) {
            setGenerating(false);
            NotificationManager.error('Błąd podczas generowania faktur');
        }
    };
    const handleSubmit = (e) => {
        setFormSkelOpen(false)
        if (e && e.preventDefault) e.preventDefault();
        generateInvoices();
    };

    const deleteInvoice = (invoiceId) => {
        if (!window.confirm('Czy na pewno chcesz usunąć tę fakturę?')) return
        fetchMssqlApi(`invoice/${invoiceId}`, {method: 'DELETE'}, () => {
            getInvoices()
        }, err => {
            console.error('deleteInvoice error', err)
        })
    }
    const [formSkelOpen, setFormSkelOpen] = useState(false);

    const openFormSkel = () => {
        if (!actionYear || !actionMonth) {
            window.alert("Aby wygenerować faktury, musisz najpierw wybrać Rok i Miesiąc w panelu operacji.");
            return;
        }

        const range = getActionRange(actionYear, actionMonth);
        const alreadyExists = invoices.some(inv => {
            const matchMonth = inv.IssuedFor === range.issuedFor;
            const matchClient = actionClient ? inv.CustomerAbbr === actionClient : true;
            return matchMonth && matchClient;
        });

        if (alreadyExists) {
            window.alert(`Faktury dla wybranego miesiąca (${range.issuedFor})${actionClient ? ' i klienta ' + actionClient : ''} zostały już wygenerowane. Generowanie kolejnych dla tego samego okresu zostało zablokowane.`);
            return;
        }

        if (window.confirm(`Czy na pewno chcesz wygenerować faktury za miesiąc ${range.issuedFor}?`)) {
            setFormSkelOpen(true);
        }
    }

    const closeFormSkel = () => {
        setFormSkelOpen(false);
    }

    const changeInvoiceStatus = async (invoiceId, newStatus) => {
        if (newStatus === 'A') {
            if (!window.confirm("Czy na pewno chcesz cofnąć zatwierdzenie?")) return;
        }

        fetchMssqlApi(`invoice/${invoiceId}/status`, {
            method: 'PUT',
            data: {
                invoiceId: invoiceId,
                newStatus: newStatus
            },
        }, () => {
            console.log("Status zmieniony");
            getInvoices();
        })
    }

    const generateInvoicePdf = (id, customerAbbr) => {
        return new Promise((resolve, reject) => {
            setGenerating(true);
            fetchMssqlApi(
                'invoice/generate-pdf',
                {
                    method: 'POST',
                    data: { invoiceId: id, customerAbbr: customerAbbr },
                    hideNotification: false 
                },
                (res) => {
                    setGenerating(false);
                    resolve(res); 
                },
                (err) => {
                    setGenerating(false);
                    reject(err);
                }
            );
        });
    };

    const downloadInvoicePdf = (id, inv) => {
        fetchMssqlApi(
            `invoice/download-pdf/${inv.CustomerAbbr}/${inv.InvoiceId}`,
            {
                method: 'GET',
                responseType: 'blob',
                hideNotification: true
            },
            (res) => {
                const blob = new Blob([res], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);

                let name = `FV_${inv.IssuedFor.replace("-", "_")}_${inv.InternalNumber.split("/")[2]}_${inv.customerAbbr}.pdf`;

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            },
            (err) => {
                console.error(err);
                window.alert("Błąd podczas pobierania pliku");
            }
        );
    };

    const handlePdfClick = async (id, inv) => {
        console.log(inv)
        try {
            await generateInvoicePdf(inv.InvoiceId, inv.CustomerAbbr);
            
            console.log("PDF wygenerowany, zaczynam pobieranie...");
            
            downloadInvoicePdf(id, inv);
        } catch (err) {
            console.log(err)
            console.error("Nie udało się wygenerować PDF, przerywam pobieranie.");
            NotificationManager.error("Nie udało się wygenerować PDF faktury. Spróbuj ponownie lub skontaktuj się ze wsparciem technicznym.");
        }
    };

    const handleSendClick = async (inv) => {
               try {
        
                    await fetchMssqlApi(
                        'invoice/send-email',
                        {
                            method: 'POST',
                            isErrorAcceptable: true,
                            data: {
                                invoiceId: inv.InternalNumber.split("/")[2],
                                customerAbbr: inv.CustomerAbbr
                            },
                            hideNotification: true
                        },
                        (res) => {
                            if (res.status === 200) {
                                NotificationManager.success(res.success)
                            } else {
                                NotificationManager.error(res.error)
                            }
                        }
                    );
                } catch (err) {
                    console.error("Critical email error:", err);
                }
    }

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDir(sortDir === 'ASC' ? 'DESC' : 'ASC');
        } else {
            setSortField(field);
            setSortDir('DESC');
        }
    };

    const renderSortIcon = (field) => {
        if (sortField !== field) return <i className="fas fa-sort ml-1 text-muted" style={{cursor: 'pointer'}} onClick={() => handleSort(field)}></i>;
        return sortDir === 'ASC' ? <i className="fas fa-sort-up ml-1" style={{cursor: 'pointer'}} onClick={() => handleSort(field)}></i> : <i className="fas fa-sort-down ml-1" style={{cursor: 'pointer'}} onClick={() => handleSort(field)}></i>;
    };

    const getDifferenceInfo = (inv) => {
        if (!inv.IssuedFor) return { hasDiff: false, message: '' };
        const [year, month] = inv.IssuedFor.split('-');
        let prevMonth = parseInt(month, 10) - 1;
        let prevYear = parseInt(year, 10);
        if (prevMonth === 0) {
            prevMonth = 12;
            prevYear -= 1;
        }
        const prevIssuedFor = `${prevYear}-${prevMonth.toString().padStart(2, '0')}`;
        const prevInvoice = invoices.find(i => i.CustomerAbbr === inv.CustomerAbbr && i.IssuedFor === prevIssuedFor);
        
        if (!prevInvoice) {
            return { hasDiff: false, isNewPeriod: true, message: 'Brak wcześniejszej faktury do porównania' };
        }
        
        const curItems = invoicesDetails.filter(d => d.InvoiceId === inv.InvoiceId && !d.isDeleted);
        const prevItems = invoicesDetails.filter(d => d.InvoiceId === prevInvoice.InvoiceId && !d.isDeleted);
        
        const differences = [];
        for (const curItem of curItems) {
            const pItem = prevItems.find(p => p.ProductNo === curItem.ProductNo);
            if (!pItem) {
                differences.push(`Nowa pozycja (kod ${curItem.ProductNo})`);
            } else {
                if (Number(pItem.Quantity) !== Number(curItem.Quantity)) {
                    differences.push(`Ilość: ${pItem.Quantity} -> ${curItem.Quantity} szt.`);
                }
                if (Number(pItem.PriceNetto) !== Number(curItem.PriceNetto)) {
                    differences.push(`Cena: ${Number(pItem.PriceNetto).toFixed(2)} -> ${Number(curItem.PriceNetto).toFixed(2)} zł`);
                }
                if (Boolean(pItem.IsPLN) !== Boolean(curItem.IsPLN)) {
                    differences.push(`Waluta: zmiana PLN/EUR`);
                }
            }
        }
        return {
            hasDiff: differences.length > 0,
            message: differences.length > 0 ? differences.join(' | ') : 'Brak zmian względem poprzedniego miesiąca'
        };
    };

    const hasDifferences = (inv) => {
        const info = getDifferenceInfo(inv);
        return info.hasDiff;
    };

    const filteredInvoices = invoices.filter(inv => {
        if (filterClient && inv.CustomerAbbr !== filterClient) return false;
        if (!inv.IssuedFor) return true;
        const [invYear, invMonth] = inv.IssuedFor.split('-');
        if (filterYear && invYear !== String(filterYear)) return false;
        if (filterMonth && invMonth !== String(filterMonth).padStart(2, '0')) return false;
        if (searchTerm && searchTerm.trim()) {
            const term = searchTerm.trim().toLowerCase();
            const num = (inv.InternalNumber || '').toLowerCase();
            const client = (inv.CustomerAbbr || '').toLowerCase();
            if (!num.includes(term) && !client.includes(term)) return false;
        }
        return true;
    });

    const isFilterActive = Boolean(filterYear || filterMonth || filterClient || searchTerm);
    const resetFilters = () => {
        setFilterYear('');
        setFilterMonth('');
        setFilterClient('');
        setSearchTerm('');
        setPage(1);
    };

    const formatCurrency = (val) => {
        const num = parseFloat(val);
        if (isNaN(num)) return '0,00 zł';
        return num.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł';
    };

    const renderStatusBadge = (status) => {
        switch (status) {
            case "A":
                return (
                    <span
                        className="badge px-2 py-1 font-weight-normal d-inline-flex align-items-center"
                        style={{
                            backgroundColor: "#f1f5f9",
                            color: "#475569",
                            border: "1px solid #cbd5e1",
                            borderRadius: "6px",
                            fontSize: "0.80rem"
                        }}
                    >
                        <i className="fas fa-circle mr-1 text-secondary" style={{ fontSize: "7px", padding: 0 }}></i>
                        Wyliczona
                    </span>
                );
            case "B":
                return (
                    <span
                        className="badge px-2 py-1 font-weight-normal d-inline-flex align-items-center"
                        style={{
                            backgroundColor: "#eff6ff",
                            color: "#1d4ed8",
                            border: "1px solid #bfdbfe",
                            borderRadius: "6px",
                            fontSize: "0.80rem"
                        }}
                    >
                        <i className="fas fa-check-circle mr-1 text-primary" style={{ fontSize: "0.85rem", padding: 0 }}></i>
                        Zatwierdzona
                    </span>
                );
            case "C":
                return (
                    <span
                        className="badge px-2 py-1 font-weight-normal d-inline-flex align-items-center"
                        style={{
                            backgroundColor: "#f0fdf4",
                            color: "#15803d",
                            border: "1px solid #bbf7d0",
                            borderRadius: "6px",
                            fontSize: "0.80rem"
                        }}
                    >
                        <i className="fas fa-paper-plane mr-1 text-success" style={{ fontSize: "0.85rem", padding: 0 }}></i>
                        Wysłana
                    </span>
                );
            default:
                return <span className="badge badge-light border">{statusToString(status) || status}</span>;
        }
    };

    const totalCount = filteredInvoices.length;
    const totalNetto = filteredInvoices.reduce((acc, inv) => {
        return acc + (parseFloat(getInvoiceTotal(inv, invoicesDetails)) || 0);
    }, 0);
    const totalBrutto = totalNetto * 1.23;
    const pendingApprovalCount = filteredInvoices.filter(inv => inv.Status === 'A').length;
    const changedCount = filteredInvoices.filter(inv => hasDifferences(inv)).length;

    const getInvoiceLp = (inv, fallbackIdx) => {
        if (!inv || !inv.InternalNumber) return fallbackIdx;
        const parts = String(inv.InternalNumber).split('/');
        if (parts.length >= 3) {
            const parsed = parseInt(parts[2], 10);
            if (!isNaN(parsed)) return parsed;
        } else if (parts.length === 2) {
            const parsed = parseInt(parts[1], 10);
            if (!isNaN(parsed)) return parsed;
        }
        const match = String(inv.InternalNumber).match(/\d+/g);
        if (match && match.length > 0) {
            const lastNum = match[match.length - 1];
            const parsed = parseInt(lastNum, 10);
            if (!isNaN(parsed)) return parsed;
        }
        return fallbackIdx;
    };

    const sortedInvoices = [...filteredInvoices].sort((a, b) => {
        if (sortField === 'Lp') {
            const lpA = getInvoiceLp(a, 0);
            const lpB = getInvoiceLp(b, 0);
            return sortDir === 'ASC' ? lpA - lpB : lpB - lpA;
        }

        let valA = a[sortField];
        let valB = b[sortField];
        
        if (valA === null || valA === undefined) valA = '';
        if (valB === null || valB === undefined) valB = '';

        if (valA < valB) return sortDir === 'ASC' ? -1 : 1;
        if (valA > valB) return sortDir === 'ASC' ? 1 : -1;
        return 0;
    });

    useEffect(() => {
        if (invoicesLoaded) {
            const lastPage = Math.max(1, Math.ceil(filteredInvoices.length / rowsPerPage));
            setPage(currentPage => Math.min(currentPage, lastPage));
        }
    }, [invoicesLoaded, filteredInvoices.length, rowsPerPage]);

    useLayoutEffect(() => {
        if (!invoicesLoaded || scrollRestored.current) return;
        const lastPage = Math.max(1, Math.ceil(filteredInvoices.length / rowsPerPage));
        if (page > lastPage) return;
        const frame = window.requestAnimationFrame(() => {
            window.scrollTo({ top: savedScrollTop.current, left: 0, behavior: 'auto' });
            scrollRestored.current = true;
        });
        return () => window.cancelAnimationFrame(frame);
    }, [invoicesLoaded, page, filteredInvoices.length, rowsPerPage]);

    const paginatedInvoices = sortedInvoices.slice((page - 1) * rowsPerPage, page * rowsPerPage);

    const years = []
    for (let y = currentYear + 5; y >= currentYear - 3; y--) years.push(y)

    const months = [
        {value: 1, label: 'Styczeń'},
        {value: 2, label: 'Luty'},
        {value: 3, label: 'Marzec'},
        {value: 4, label: 'Kwiecień'},
        {value: 5, label: 'Maj'},
        {value: 6, label: 'Czerwiec'},
        {value: 7, label: 'Lipiec'},
        {value: 8, label: 'Sierpień'},
        {value: 9, label: 'Wrzesień'},
        {value: 10, label: 'Październik'},
        {value: 11, label: 'Listopad'},
        {value: 12, label: 'Grudzień'},
    ]

    const getMonthName = (issuedFor) => {
        if (!issuedFor) return '';
        const parts = String(issuedFor).split('-');
        if (parts.length >= 2) {
            const m = parseInt(parts[1], 10);
            const found = months.find(item => item.value === m);
            return found ? found.label : '';
        }
        return '';
    };

    const noWrapStyle = { whiteSpace: "nowrap", maxWidth: "none" };

    return (
        <>
            <Prompt
                when={generating}
                message="Trwa generowanie faktur. Opuszczenie tej strony może przerwać proces w bazie danych. Czy na pewno chcesz wyjść?"
            />
            <div>
                {formSkelOpen && (
                    <FormSkel
                        headerText={"Generowanie faktur/y"}
                        handleClose={closeFormSkel}
                        handleSubmit={handleSubmit}

                    >
                        <form id='modal-form' onSubmit={handleSubmit}>
                            <div>
                                <p className="mb-1">Okres generowania: <strong>{actionYear}-{String(actionMonth).padStart(2, '0')} ({months.find(m => m.value === actionMonth) ? months.find(m => m.value === actionMonth).label : actionMonth} {actionYear})</strong></p>
                                <p className="mb-1 text-muted small">Zakres dat: <strong>{getActionRange(actionYear, actionMonth).from}</strong> do <strong>{getActionRange(actionYear, actionMonth).to}</strong></p>
                                <p>Klient: <strong>{actionClient ? actionClient : 'Wszyscy klienci'}</strong></p>
                                <hr/>
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                    <label className="font-weight-bold mb-0">Aktualny kurs EUR</label>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={fetchNbpRate}
                                        disabled={fetchingNbp}
                                        style={{ fontSize: "0.8rem", padding: "0.2rem 0.55rem" }}
                                    >
                                        {fetchingNbp ? (
                                            <><span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span> Pobieranie...</>
                                        ) : (
                                            <><i className="fas fa-cloud-download-alt mr-1"></i> Pobierz kurs NBP</>
                                        )}
                                    </button>
                                </div>
                                <input
                                    className="form-control"
                                    value={eurRate}
                                    onChange={e => {
                                        const val = e.target.value.replace(',', '.');
                                        if (val === '' || /^\d*\.?\d{0,4}$/.test(val)) {
                                            setEurRate(val);
                                        }
                                    }}
                                    required={true}
                                    type="text"
                                    inputMode="decimal"
                                    placeholder="np. 4.3300"
                                />
                                <br/>
                                <label className="font-weight-bold">Od którego numeru faktury np. 2025/0000301</label>
                                <input
                                     className="form-control"
                                     value={startInvoiceNumber}
                                     onChange={e => setStartInvoiceNumber(e.target.value)}
                                     placeholder="np. 301"
                                 />
                            </div>
                        </form>
                    </FormSkel>
                )}

                {generating && (
                    <div className="alert alert-warning shadow-sm border-0 d-flex align-items-center mb-3">
                        <span className="spinner-border spinner-border-sm mr-2 text-warning" role="status" aria-hidden="true"></span>
                        <div className="flex-grow-1">
                            <strong>Trwa generowanie faktur w tle...</strong> Prosimy nie zamykać ani nie odświeżać tej strony, aby nie przerwać procesu wystawiania faktur.
                        </div>
                    </div>
                )}

                <div className="row mb-3 mt-2">
                    <div className="col-12 col-sm-6 col-lg-3 mb-2">
                        <div className="card shadow-sm h-100 border-0" style={{ backgroundColor: "#ffffff", borderLeft: "4px solid #0140BE" }}>
                            <div className="card-body p-3 d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-muted small text-uppercase font-weight-bold" style={{ letterSpacing: "0.5px" }}>Faktury na liście</div>
                                    <div className="h4 font-weight-bold text-dark mb-0 mt-1">{totalCount}</div>
                                    <small className="text-muted">
                                        {filterMonth && months.find(m => m.value === filterMonth) ? months.find(m => m.value === filterMonth).label : 'Wszystkie m-ce'} {filterYear || ''}
                                    </small>
                                </div>
                                <div className="p-3 rounded-circle text-primary" style={{ backgroundColor: "#eff6ff" }}>
                                    <i className="fas fa-file-invoice fa-lg"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 mb-2">
                        <div className="card shadow-sm h-100 border-0" style={{ backgroundColor: "#ffffff", borderLeft: "4px solid #139108" }}>
                            <div className="card-body p-3 d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-muted small text-uppercase font-weight-bold" style={{ letterSpacing: "0.5px" }}>Suma Netto</div>
                                    <div className="h4 font-weight-bold mb-0 mt-1" style={{ color: "#139108" }}>{formatCurrency(totalNetto)}</div>
                                    <small className="text-muted">Brutto: {formatCurrency(totalBrutto)}</small>
                                </div>
                                <div className="p-3 rounded-circle text-success" style={{ backgroundColor: "#f0fdf4" }}>
                                    <i className="fas fa-wallet fa-lg"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 mb-2">
                        <div className="card shadow-sm h-100 border-0" style={{ backgroundColor: "#ffffff", borderLeft: "4px solid #f59e0b" }}>
                            <div className="card-body p-3 d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-muted small text-uppercase font-weight-bold" style={{ letterSpacing: "0.5px" }}>Do zatwierdzenia</div>
                                    <div className="h4 font-weight-bold text-dark mb-0 mt-1">{pendingApprovalCount} <span className="text-muted small font-weight-normal">/ {totalCount}</span></div>
                                    <small className="text-warning font-weight-bold">{pendingApprovalCount > 0 ? 'Wymaga weryfikacji' : 'Wszystkie zatwierdzone'}</small>
                                </div>
                                <div className="p-3 rounded-circle" style={{ backgroundColor: "#fffbeb", color: "#d97706" }}>
                                    <i className="fas fa-clock fa-lg"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 mb-2">
                        <div className="card shadow-sm h-100 border-0" style={{ backgroundColor: "#ffffff", borderLeft: "4px solid #6366f1" }}>
                            <div className="card-body p-3 d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-muted small text-uppercase font-weight-bold" style={{ letterSpacing: "0.5px" }}>Wykryte zmiany M/M</div>
                                    <div className="h4 font-weight-bold mb-0 mt-1" style={{ color: "#4f46e5" }}>{changedCount}</div>
                                    <small className="text-muted">Różnice ilości lub ceny</small>
                                </div>
                                <div className="p-3 rounded-circle" style={{ backgroundColor: "#eef2ff", color: "#4f46e5" }}>
                                    <i className="fas fa-chart-line fa-lg"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 2. Dedykowany Panel: Generowanie faktur i pobieranie raportów */}
                <div className="card shadow-sm border-0 mb-3" style={{ backgroundColor: "#ffffff" }}>
                    <div className="card-header bg-white py-2 px-3 border-bottom d-flex flex-wrap align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <span className="font-weight-bold text-dark" style={{ fontSize: "0.92rem" }}>
                                <i className="fas fa-cogs text-primary mr-2"></i> Generowanie faktur & Raporty
                            </span>
                            <span className="badge badge-light border text-primary ml-2 px-2 py-1 font-weight-bold" style={{ fontSize: "0.78rem" }}>
                                Okres operacji: {actionYear}-{String(actionMonth).padStart(2, '0')}
                            </span>
                        </div>
                        <small className="text-muted">
                            Wybór okresu w tej sekcji dotyczy operacji generowania i raportów
                        </small>
                    </div>
                    <div className="card-body p-3">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex flex-wrap align-items-center" style={{ gap: "12px" }}>
                                <div className="d-flex align-items-center mr-2 mb-2 mb-lg-0">
                                    <span className="font-weight-bold text-secondary mr-2 small text-uppercase">Rok:</span>
                                    <select
                                        className="form-control form-control-sm font-weight-bold"
                                        style={{ minWidth: "90px" }}
                                        value={actionYear}
                                        onChange={e => setActionYear(Number(e.target.value))}
                                    >
                                        {years.map(y => <option key={y} value={y}>{y}</option>)}
                                    </select>
                                </div>

                                <div className="d-flex align-items-center mr-2 mb-2 mb-lg-0">
                                    <span className="font-weight-bold text-secondary mr-2 small text-uppercase">Miesiąc:</span>
                                    <select
                                        className="form-control form-control-sm font-weight-bold"
                                        style={{ minWidth: "120px" }}
                                        value={actionMonth}
                                        onChange={e => setActionMonth(Number(e.target.value))}
                                    >
                                        {months.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                                    </select>
                                </div>

                                <div className="d-flex align-items-center mr-2 mb-2 mb-lg-0">
                                    <span className="font-weight-bold text-secondary mr-2 small text-uppercase">Klient:</span>
                                    <select
                                        className="form-control form-control-sm"
                                        style={{ minWidth: "160px" }}
                                        value={actionClient}
                                        onChange={e => setActionClient(e.target.value)}
                                    >
                                        <option value="">Wszyscy ({clients.length})</option>
                                        {[...clients]
                                            .sort((a, b) => {
                                                const aa = (a && (a.Abbreviation || a.Name || '')).toString();
                                                const bb = (b && (b.Abbreviation || b.Name || '')).toString();
                                                return aa.localeCompare(bb, 'pl', {sensitivity: 'base'});
                                            })
                                            .map((c, idx) => (
                                                <option key={idx} value={c.Abbreviation}>
                                                    {c.Abbreviation || c.Name || ''}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>

                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <button
                                    className="btn btn-primary btn-sm font-weight-bold px-3 mr-2 shadow-sm"
                                    onClick={openFormSkel}
                                    disabled={generating}
                                >
                                    {generating ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                            Generowanie...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-magic mr-1"></i> Generuj faktury
                                        </>
                                    )}
                                </button>

                                <div className="btn-group btn-group-sm">
                                    <ReportButton
                                        reportId={94}
                                        body={() => {
                                            const range = getActionRange(actionYear, actionMonth);
                                            return {
                                                fromCreateDateTime: range.from,
                                                toCreateDateTime: range.to,
                                                customerAbbr: actionClient,
                                            };
                                        }}
                                        btnColor="outline-primary"
                                    />
                                    <ReportButton
                                        reportId={107}
                                        body={() => {
                                            const range = getActionRange(actionYear, actionMonth);
                                            return {
                                                fromCreateDateTime: range.from,
                                                toCreateDateTime: range.to,
                                                customerAbbr: actionClient,
                                            };
                                        }}
                                        btnColor="outline-success"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 3. Dedykowany Panel: Filtrowanie widoku listy w tabeli */}
                <div className="card shadow-sm border-0 mb-3" style={{ backgroundColor: "#ffffff" }}>
                    <div className="card-body p-3">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex flex-wrap align-items-center" style={{ gap: "12px" }}>
                                <div className="d-flex align-items-center mr-2 mb-2 mb-lg-0">
                                    <span className="font-weight-bold text-dark mr-1 small text-uppercase">
                                        <i className="fas fa-filter text-secondary mr-1"></i> Filtruj listę:
                                    </span>
                                </div>

                                <div className="d-flex align-items-center mr-2 mb-2 mb-lg-0">
                                    <span className="text-secondary mr-2 small">Rok:</span>
                                    <select
                                        className="form-control form-control-sm"
                                        style={{ minWidth: "90px" }}
                                        value={filterYear || ""}
                                        onChange={e => {
                                            setFilterYear(e.target.value ? Number(e.target.value) : "");
                                            setPage(1);
                                        }}
                                    >
                                        <option value="">Wszystkie</option>
                                        {years.map(y => <option key={y} value={y}>{y}</option>)}
                                    </select>
                                </div>

                                <div className="d-flex align-items-center mr-2 mb-2 mb-lg-0">
                                    <span className="text-secondary mr-2 small">Miesiąc:</span>
                                    <select
                                        className="form-control form-control-sm"
                                        style={{ minWidth: "120px" }}
                                        value={filterMonth || ""}
                                        onChange={e => {
                                            setFilterMonth(e.target.value ? Number(e.target.value) : "");
                                            setPage(1);
                                        }}
                                    >
                                        <option value="">Wszystkie</option>
                                        {months.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                                    </select>
                                </div>

                                <div className="d-flex align-items-center mr-2 mb-2 mb-lg-0">
                                    <span className="text-secondary mr-2 small">Klient:</span>
                                    <select
                                        className="form-control form-control-sm"
                                        style={{ minWidth: "160px" }}
                                        value={filterClient}
                                        onChange={e => {
                                            setFilterClient(e.target.value);
                                            setPage(1);
                                        }}
                                    >
                                        <option value="">Wszyscy ({clients.length})</option>
                                        {[...clients]
                                            .sort((a, b) => {
                                                const aa = (a && (a.Abbreviation || a.Name || '')).toString();
                                                const bb = (b && (b.Abbreviation || b.Name || '')).toString();
                                                return aa.localeCompare(bb, 'pl', {sensitivity: 'base'});
                                            })
                                            .map((c, idx) => (
                                                <option key={idx} value={c.Abbreviation}>
                                                    {c.Abbreviation || c.Name || ''}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="d-flex align-items-center mb-2 mb-lg-0">
                                    <div className="input-group input-group-sm">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text bg-white border-right-0 text-muted">
                                                <i className="fas fa-search"></i>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control border-left-0"
                                            placeholder="Szukaj po nr lub kliencie..."
                                            value={searchTerm}
                                            onChange={e => {
                                                setSearchTerm(e.target.value);
                                                setPage(1);
                                            }}
                                            style={{ maxWidth: "210px" }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {isFilterActive && (
                                <div className="mt-2 mt-lg-0">
                                    <button
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={resetFilters}
                                        title="Wyczyść wszystkie filtry listy"
                                    >
                                        <i className="fas fa-times mr-1"></i> Wyczyść filtry
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* 3. Modern Financial Table Card */}
                <div className='card shadow-sm border-0'>
                    <div className="card-header bg-white py-3 border-bottom d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            <h6 className="font-weight-bold mb-0 text-dark">
                                Lista dokumentów
                            </h6>
                            <span className="badge badge-primary ml-2 px-2 py-1 font-weight-normal" style={{ fontSize: "0.8rem" }}>
                                {filteredInvoices.length} {filteredInvoices.length === 1 ? 'faktura' : 'faktur'}
                            </span>
                        </div>
                        <div className="d-flex align-items-center">
                            <PaginationEx
                                rowsPerPage={rowsPerPage}
                                page={page}
                                rowsCount={paginatedInvoices.length}
                                handleSwitchPage={setPage}
                                resetBtnVis={false}
                            />
                        </div>
                    </div>

                    <div className='card-body p-0'>
                        {filteredInvoices.length !== 0 ? (
                            <div style={{ overflowX: "auto", width: "100%" }}>
                                <table className='table table-hover mb-0' style={{ minWidth: "1420px" }}>
                                    <thead style={{ backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                                        <tr>
                                            <th style={{ ...noWrapStyle, width: "55px", minWidth: "55px", textAlign: "center", paddingLeft: "16px", cursor: "pointer" }} onClick={() => handleSort('Lp')}>
                                                Lp. {renderSortIcon('Lp')}
                                            </th>
                                            <th style={{ ...noWrapStyle, width: "45px", minWidth: "45px", textAlign: "center" }} title="Wykryte zmiany względem poprzedniego miesiąca">
                                                Zmiana
                                            </th>
                                            <th style={{ ...noWrapStyle, minWidth: "160px", cursor: "pointer", paddingLeft: "12px" }} onClick={() => handleSort('InternalNumber')}>
                                                Numer faktury {renderSortIcon('InternalNumber')}
                                            </th>
                                            <th style={{ ...noWrapStyle, minWidth: "90px", cursor: "pointer" }} onClick={() => handleSort('CustomerAbbr')}>
                                                Klient {renderSortIcon('CustomerAbbr')}
                                            </th>
                                            <th style={{ ...noWrapStyle, minWidth: "95px", cursor: "pointer" }} onClick={() => handleSort('IssuedFor')}>
                                                Okres {renderSortIcon('IssuedFor')}
                                            </th>
                                            <th style={{ ...noWrapStyle, minWidth: "145px", cursor: "pointer" }} onClick={() => handleSort('CreateDateTime')}>
                                                Data utworzenia {renderSortIcon('CreateDateTime')}
                                            </th>
                                            <th style={{ ...noWrapStyle, minWidth: "100px", textAlign: "right" }}>
                                                Ilość (terminale)
                                            </th>
                                            <th style={{ ...noWrapStyle, minWidth: "115px", textAlign: "right" }}>
                                                Wartość Netto
                                            </th>
                                            <th style={{ ...noWrapStyle, minWidth: "115px", textAlign: "right" }}>
                                                Wartość Brutto
                                            </th>
                                            <th style={{ ...noWrapStyle, minWidth: "105px", textAlign: "center", cursor: "pointer" }} onClick={() => handleSort('PriceEUR')}>
                                                Kurs EUR {renderSortIcon('PriceEUR')}
                                            </th>
                                            <th style={{ ...noWrapStyle, width: "140px", minWidth: "140px", textAlign: "center", cursor: "pointer" }} onClick={() => handleSort('Status')}>
                                                Status {renderSortIcon('Status')}
                                            </th>
                                            <th style={{ ...noWrapStyle, width: "300px", minWidth: "300px", textAlign: "right", paddingRight: "16px" }}>
                                                Akcje
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedInvoices.map((inv, idx) => {
                                            const diffInfo = getDifferenceInfo(inv);
                                            const totalQty = invoicesDetails
                                                .filter(detail => detail.InvoiceId === inv.InvoiceId && !detail.isDeleted)
                                                .reduce((sum, detail) => sum + (detail.Quantity || 0), 0);
                                            const netto = parseFloat(getInvoiceTotal(inv, invoicesDetails) || 0);
                                            const brutto = netto * 1.23;

                                            return (
                                                <tr key={idx} style={{ borderBottom: "1px solid #f1f5f9" }}>
                                                    <td className="align-middle text-center text-muted font-weight-bold" style={{ ...noWrapStyle, width: "55px", minWidth: "55px", paddingLeft: "16px", fontSize: "0.82rem" }}>
                                                        {getInvoiceLp(inv, (page - 1) * rowsPerPage + idx + 1)}
                                                    </td>

                                                    <td className="align-middle text-center" style={{ ...noWrapStyle, width: "45px", minWidth: "45px" }}>
                                                        {diffInfo.hasDiff ? (
                                                            <OverlayTrigger
                                                                placement="right"
                                                                overlay={<Tooltip id={`tooltip-inv-diff-${idx}`}>{diffInfo.message}</Tooltip>}
                                                            >
                                                                <span
                                                                    className="d-inline-flex align-items-center justify-content-center"
                                                                    style={{
                                                                        width: "24px",
                                                                        height: "24px",
                                                                        borderRadius: "50%",
                                                                        backgroundColor: "#fef3c7",
                                                                        color: "#d97706",
                                                                        cursor: "help",
                                                                        fontSize: "0.75rem"
                                                                    }}
                                                                >
                                                                    <i className="fas fa-asterisk"></i>
                                                                </span>
                                                            </OverlayTrigger>
                                                        ) : (
                                                            <span className="text-muted small" title="Brak zmian">—</span>
                                                        )}
                                                    </td>

                                                    {/* Invoice number */}
                                                    <td className="align-middle" style={{ ...noWrapStyle, paddingLeft: "12px" }}>
                                                        <span style={{ fontFamily: "SFMono-Regular, Menlo, Monaco, Consolas, monospace", fontWeight: "600", color: "#0f172a" }}>
                                                            {inv.InternalNumber}
                                                        </span>
                                                    </td>

                                                    <td className="align-middle" style={noWrapStyle}>
                                                        <span className="badge badge-light px-2 py-1 border text-dark font-weight-bold" style={{ backgroundColor: "#f8fafc", fontSize: "0.82rem" }}>
                                                            {inv.CustomerAbbr}
                                                        </span>
                                                    </td>

                                                    <td className="align-middle" style={{ ...noWrapStyle, minWidth: "95px" }}>
                                                        <div className="font-weight-bold text-dark" style={{ fontSize: "0.85rem", lineHeight: "1.2" }}>
                                                            {inv.IssuedFor}
                                                        </div>
                                                        {getMonthName(inv.IssuedFor) && (
                                                            <div className="text-muted" style={{ fontSize: "0.75rem", lineHeight: "1.2" }}>
                                                                {getMonthName(inv.IssuedFor)}
                                                            </div>
                                                        )}
                                                    </td>

                                                    {/* Created at */}
                                                    <td className="align-middle text-muted" style={{ ...noWrapStyle, fontSize: "0.82rem" }}>
                                                        {inv.CreateDateTime ? inv.CreateDateTime.replace("T", " ").slice(0, 19) : "—"}
                                                    </td>

                                                    {/* Quantity */}
                                                    <td className="align-middle text-right" style={noWrapStyle}>
                                                        <span className="badge badge-light px-2 py-1 border text-secondary font-weight-bold" style={{ fontSize: "0.85rem" }}>
                                                            {totalQty} szt.
                                                        </span>
                                                    </td>

                                                    {/* Netto */}
                                                    <td className="align-middle text-right" style={{ ...noWrapStyle, fontWeight: "600", color: "#0f172a" }}>
                                                        {formatCurrency(netto)}
                                                    </td>

                                                    <td className="align-middle text-right" style={{ ...noWrapStyle, color: "#64748b", fontSize: "0.88rem" }}>
                                                        {formatCurrency(brutto)}
                                                    </td>

                                                    <td className="align-middle text-center" style={{ ...noWrapStyle, fontFamily: "monospace", fontSize: "0.85rem" }}>
                                                        {inv.PriceEUR ? Number(inv.PriceEUR).toFixed(4) + ' zł' : '—'}
                                                    </td>

                                                    <td className="align-middle text-center" style={{ ...noWrapStyle, width: "140px", minWidth: "140px" }}>
                                                        {renderStatusBadge(inv.Status)}
                                                    </td>

                                                    <td className="align-middle text-right" style={{ ...noWrapStyle, width: "300px", minWidth: "300px", paddingRight: "16px" }}>
                                                        <div className="d-flex justify-content-end align-items-center" style={{ flexWrap: "nowrap", whiteSpace: "nowrap" }}>
                                                            {inv.Status !== 'B' ? (
                                                                <>
                                                                    <button
                                                                        className="btn btn-outline-success btn-sm font-weight-bold mr-1"
                                                                        onClick={() => changeInvoiceStatus(inv.InvoiceId, 'B')}
                                                                        title="Zatwierdź fakturę do wysyłki"
                                                                        style={{ padding: "0.25rem 0.6rem", fontSize: "0.80rem", whiteSpace: "nowrap" }}
                                                                    >
                                                                        <i className="fas fa-check mr-1" style={{ padding: 0 }}></i> Zatwierdź
                                                                    </button>
                                                                    <Link
                                                                        className="btn btn-outline-primary btn-sm mr-1"
                                                                        title="Edytuj pozycje"
                                                                        to={"/invoices/" + inv.InvoiceId}
                                                                        style={{ padding: "0.25rem 0.45rem" }}
                                                                    >
                                                                        <i className="fas fa-edit" style={{ padding: 0 }}></i>
                                                                    </Link>
                                                                    <button
                                                                        className="btn btn-outline-danger btn-sm"
                                                                        title="Usuń fakturę"
                                                                        onClick={() => deleteInvoice(inv.InvoiceId)}
                                                                        style={{ padding: "0.25rem 0.45rem" }}
                                                                    >
                                                                        <i className="fas fa-trash" style={{ padding: 0 }}></i>
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm mr-1 font-weight-bold"
                                                                        onClick={() => handlePdfClick(inv.InternalNumber.split("/")[2], inv)}
                                                                        title="Pobierz PDF faktury"
                                                                        style={{ padding: "0.25rem 0.5rem", fontSize: "0.80rem", whiteSpace: "nowrap" }}
                                                                    >
                                                                        <i className="fas fa-file-pdf mr-1" style={{ padding: 0 }}></i> PDF
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-outline-secondary btn-sm mr-1 font-weight-bold"
                                                                        onClick={() => handleSendClick(inv)}
                                                                        title="Wyślij e-mail do klienta"
                                                                        style={{ padding: "0.25rem 0.5rem", fontSize: "0.80rem", whiteSpace: "nowrap" }}
                                                                    >
                                                                        <i className="fas fa-envelope mr-1" style={{ padding: 0 }}></i> Wyślij
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-outline-warning btn-sm mr-1"
                                                                        onClick={() => changeInvoiceStatus(inv.InvoiceId, 'A')}
                                                                        title="Cofnij zatwierdzenie (powrót do roboczej)"
                                                                        style={{ padding: "0.25rem 0.45rem" }}
                                                                    >
                                                                        <i className="fas fa-undo" style={{ padding: 0 }}></i>
                                                                    </button>
                                                                    <Link
                                                                        className="btn btn-outline-primary btn-sm mr-1"
                                                                        title="Edytuj pozycje"
                                                                        to={"/invoices/" + inv.InvoiceId}
                                                                        style={{ padding: "0.25rem 0.45rem" }}
                                                                    >
                                                                        <i className="fas fa-edit" style={{ padding: 0 }}></i>
                                                                    </Link>
                                                                    <button
                                                                        className="btn btn-outline-danger btn-sm"
                                                                        title="Usuń fakturę"
                                                                        onClick={() => deleteInvoice(inv.InvoiceId)}
                                                                        style={{ padding: "0.25rem 0.45rem" }}
                                                                    >
                                                                        <i className="fas fa-trash" style={{ padding: 0 }}></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <NoResults />
                        )}
                    </div>
                </div>

            </div>
        </>
    )

}
export  const statusToString = (status) => {
    switch (status) {
        case "A":
            return "Wyliczona";
        case "B":
            return "Zatwierdzona do wysyłki";
        case "C":
            return "Wysłana";
    }
}
export default Invoices;